import { USER_ROLE_LABEL, USER_STATUS_LABEL, TUserRole, TUserStatus } from "@/types/enum";
import { TOption } from "@/types/common";

export const USER_STATUS_OPTIONS: TOption[] = Object.entries(USER_STATUS_LABEL).map(([value, label]) => ({
  value: value as TUserStatus,
  label,
}));

export const USER_ROLE_OPTIONS: TOption[] = Object.entries(USER_ROLE_LABEL).map(([value, label]) => ({
  value: value as TUserRole,
  label,
}));
